import { Button, type SxProps, type ButtonProps, type Theme } from '@mui/material'
import { LightStartIcons } from './LightStartIcons'
import { unicodeStringSplit } from '../../utils/unicodeStringSplit'

export type LightsSelectorOption = { avatar: string; label: string; value: string }

export type LightButtonProps = {
    active?: boolean
    loading?: boolean
} & LightsSelectorOption &
    ButtonProps

const style: SxProps<Theme> = {
    justifyContent: 'flex-start',
    fontWeight: 700,
    '&:focus': {
        backgroundColor: (theme) => theme.palette.primary.light || '#42a5f5',
        color: (theme) => theme.palette.primary.contrastText || '#eee',
        boxShadow: (theme) => `0 0 0 4px ${theme.palette.primary.dark || '#1565c0'} inset`,
    },
}

export const LightButton = ({ avatar, label, active, loading, value, ...rest }: LightButtonProps) => {
    const variant = active ? 'contained' : 'outlined'

    if (loading) {
        return (
            <Button
                disabled
                disableFocusRipple
                sx={style}
                fullWidth
                variant={variant}
                startIcon={<LightStartIcons loading />}
                {...rest}
            >
                {label}
            </Button>
        )
    }

    if (!avatar && !label) {
        return null
    }

    const colorKeys = unicodeStringSplit(avatar || '')

    return (
        <Button
            disableFocusRipple
            sx={style}
            fullWidth
            variant={variant}
            startIcon={<LightStartIcons colors={colorKeys} />}
            {...rest}
        >
            {label}
        </Button>
    )
}
